/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Delete_Confirm_DescriptionInputs */

const he_account_notifications_delete_confirm_description = /** @type {(inputs: Account_Notifications_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פעולה זו תמחק את ההתראה לצמיתות. תוכל תמיד ליצור התראה חדשה מדף המוצר.`)
};

const en_account_notifications_delete_confirm_description = /** @type {(inputs: Account_Notifications_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will permanently remove this notification. You can always create a new one from the item page.`)
};

/**
* | output |
* | --- |
* | "This will permanently remove this notification. You can always create a new one from the item page." |
*
* @param {Account_Notifications_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_delete_confirm_description = /** @type {((inputs?: Account_Notifications_Delete_Confirm_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Delete_Confirm_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_delete_confirm_description(inputs)
	return en_account_notifications_delete_confirm_description(inputs)
});